import { FontSizeSelect } from 'modules/common/components/FontSizeSelect';
import { FontSizeSelectProps } from 'modules/common/components/FontSizeSelect/FontSizeSelect.types';
import { memo } from 'react';

export const FontSize = memo(({ onChange, onIncrement, onDecrement, value }: FontSizeSelectProps) => {
  return (
    <FontSizeSelect
      onChange={onChange}
      value={value ?? ''}
      onDecrement={onDecrement}
      onIncrement={onIncrement}
      // If true - causes onChange to fire after corner resizing since font size can change so should be kept false
      triggerBlurOnUnmount={false}
    />
  );
});
FontSize.displayName = 'FontSize';
